import axios from "axios";
import moment from "moment";
import Chart from "chart.js";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";

export default {
  name: "VisitPredictionDashboardModal",
  components: {
    customModal
  },
  emits: ["closeModal"],
  props: {
    studyId: {
      type: String,
      default: ""
    },
    siteCode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      chartInstance: null,
      hasGraphData: false,
      loading: false
    };
  },
  watch: {
    studyId: "loadGraph",
    siteCode: "loadGraph"
  },
  mounted() {
    this.loadGraph();
  },
  beforeUnmount() {
    this.destroyChart();
  },
  methods: {
    async loadGraph() {
      if (!this.studyId || !this.siteCode) {
        this.hasGraphData = false;
        this.loading = false;
        this.destroyChart();
        return;
      }

      this.loading = true;
      try {
        const response = await axios.get(
          `${this.baseurl}/forms/cra/historytrendbasedgraph`,
          {
            headers: {
              Authorization: `Bearer ${store.getters.getIdToken}`,
              "Content-Type": "application/json"
            },
            params: {
              StudyId: this.studyId,
              SiteCode: this.siteCode
            }
          }
        );

        const sites = response.data?.sites || [];
        const currentSite =
          sites.find((x) => x.siteCode === this.siteCode) || sites[0];
        const monthlyHistory = (currentSite?.monthlyHistory || [])
          .slice()
          .sort((a, b) => a.orderNo - b.orderNo);

        const labels = monthlyHistory.map((x) =>
          moment(x.createdAt).format("YYYY-MM-DD")
        );
        const values = monthlyHistory.map((x) => Number(x.averageScore || 0));

        this.hasGraphData = values.length > 0;
        this.renderLineChart(labels, values);
      } catch (error) {
        this.hasGraphData = false;
        this.destroyChart();
        console.error("Failed to load history trend graph:", error);
      } finally {
        this.loading = false;
      }
    },
    renderLineChart(labels, values) {
      if (!this.$refs.trendLineChart) return;
      this.destroyChart();

      const ctx = this.$refs.trendLineChart.getContext("2d");
      this.chartInstance = new Chart(ctx, {
        type: "line",
        data: {
          labels,
          datasets: [
            {
              label: "Average Score",
              data: values,
              borderColor: "#2b7de9",
              backgroundColor: "rgba(43, 125, 233, 0.15)",
              pointBackgroundColor: "#2b7de9",
              pointRadius: 4,
              fill: false,
              lineTension: 0.2
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: true
          },
          scales: {
            xAxes: [
              {
                scaleLabel: {
                  display: true,
                  labelString: "Created At"
                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true
                },
                scaleLabel: {
                  display: true,
                  labelString: "Average Score"
                }
              }
            ]
          }
        }
      });
    },
    destroyChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
        this.chartInstance = null;
      }
    },
    closeModal() {
      this.$emit("closeModal");
    }
  }
};
